// extracted by mini-css-extract-plugin
module.exports = {"card":"MapRestCarouselMobileNotFound_card__uFuTk","desc":"MapRestCarouselMobileNotFound_desc__M28MA"};